import FundingDescriptions from "./FundingDescriptions";

export default FundingDescriptions;
